// src/component/filtered_list.ts
var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["STORY"] = "story";
  FilterType2["TAG"] = "tag";
  return FilterType2;
})(FilterType || {});
export {
  FilterType
};
